
import { useState, useEffect } from 'react';

import ChatSidebar from '../../components/ChatSidebar/ChatSidebar';
import MainPlayerOverlays from '../../components/MainPlayerOverlays/MainPlayerOverlays';

import ChatController from '../../controllers/Chat';

import ExternalConfiguration from '../../external-configuration';

import './WithChat.css';

const calculateDimensions = (chatConfiguration, showingChat) => {
  return ChatController.onResize( chatConfiguration, showingChat);
};

const Local_Globals = {
  chatConfiguration: null,
  showingChat: null,
};

export default function WithChat( props) {
  const { chatConfiguration } = props;
  const [ showingChat, setShowingChat ] = useState( chatConfiguration.defaultShowingChat);
  Local_Globals.chatConfiguration = chatConfiguration;
  Local_Globals.showingChat = showingChat;

  const [ dimensions, setDimensions ] = useState( calculateDimensions( chatConfiguration, showingChat));

  useEffect( () => {
    const handler = () => {
      if( Local_Globals.chatConfiguration && Local_Globals.showingChat) {
        setDimensions( calculateDimensions( Local_Globals.chatConfiguration, Local_Globals.showingChat));
      }
    };
    window.addEventListener( 'resize', handler);
    return () => window.removeEventListener( 'resize', handler);
  }, []);

  useEffect( () => {
    setDimensions( calculateDimensions( chatConfiguration, showingChat));
  }, [ chatConfiguration, showingChat ]);

  if( props.custom_3_playerConfiguration?.customProps ) {
    props.custom_3_playerConfiguration.customProps.width = dimensions.width;
    props.custom_3_playerConfiguration.customProps.height = dimensions.height;
  }

  return (
    <div className='WithChat'>
      <div style={ dimensions } className='PlayerContainer'>
        { props.PlayerComponent.render( props) }
        <MainPlayerOverlays { ...props } />
        <button className='ShowHideButton' onClick={ () => setShowingChat( !showingChat)} alt='Mostrar / Ocultar Chat'>
          <img src={`${ExternalConfiguration.ResourcesPath}/Chat_ShowHide.svg`} alt='Show/Hide Chat'/>
        </button>
      </div>
      { showingChat ? <ChatSidebar chatConfiguration={ chatConfiguration}/> : '' }
    </div>
  );
}
